// reelConfig.ts

export const REEL_COLLECTION_COUNT = 2;
export const REEL_NUMBERS = 5;
export const SYMBOLS_PER_REEL = 10;
export const SYMBOL_WIDTH = 230;
export const SYMBOL_HEIGHT = 177;
export const REEL_WIDTH = SYMBOL_WIDTH;
export const REEL_DIVIDER = 32;
export const REEL_FRAME = 0;
export const NUMBER_OF_SYMBOLS = 11;
export const SHOWN_REELS_HEIGHT = SYMBOL_HEIGHT * SYMBOLS_PER_REEL;

export const REEL_BG_POS_ALL = [
    {
        "3": { bgX: 248, bgY: 230, bgScaleX: 1, bgScaleY: 0.67, reelX: 0, reelY: -983 }
    },
    {
        "4": { bgX: 248, bgY: 230, bgScaleX: 1, bgScaleY: 0.67, reelX: 0, reelY: -983 }
    },
    {
        "5": { bgX: 248, bgY: 165, bgScaleX: 1, bgScaleY: 0.84, reelX: 212, reelY: -983 }
    },
    {
        "6": { bgX: 248, bgY: 80, bgScaleX: 1, bgScaleY: 1, reelX: 0, reelY: -983 }
    },
    {
        "7": { bgX: 248, bgY: 0, bgScaleX: 1, bgScaleY: 1.15, reelX: 0, reelY: -983 }
    },
    {
        "8": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    },
    {
        "9": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    },
    {
        "10": { bgX: 248, bgY: -103, bgScaleX: 1, bgScaleY: 1.34, reelX: 0, reelY: -983 }
    }
];

export const REEL_SCALE_LANDSCAPE = [1, 1, 0.95, 0.85, 0.75, 0.65, 0.6, 0.55];
export const REEL_SCALE_PORTRAIT = [0.8, 0.8, 0.8, 0.8, 0.77, 0.75, 0.73, 0.71];
// export const REEL_X_POS_LAND = [420, 420, 370, 400, 420]
export const REEL_Y_POS_LAND = [230, 230, 300, 335, 340, 330, 350, 315];
export const REEL_Y_POS_PORT = [320, 350, 370, 410, 425, 425, 425, 425];

export let VISIBLE_SYMBOLS_PER_REEL = 3;
export let setVisibleSymbols = (newValue: number) => {
    VISIBLE_SYMBOLS_PER_REEL = newValue;
};
